module.exports = __webpack_public_path__ + "static/media/search.bd551b1a.svg";